import { render, staticRenderFns } from "./ClaimPreview.vue?vue&type=template&id=2bad18b1&scoped=true&"
import script from "./ClaimPreview.vue?vue&type=script&lang=js&"
export * from "./ClaimPreview.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ClaimPreview.vue?vue&type=style&index=1&id=2bad18b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad18b1",
  null
  
)

export default component.exports